/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE REPORTS SLICE
 * Role: Admin
 * Scope: Redux state management for fee reports & defaulters
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { createSlice } from "@reduxjs/toolkit";
import { fetchFeeReportsSummary } from "./fee_reports.thunk";

const initialState = {
  filterContext: {
    type: "monthly",
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  },
  financialSummary: {
    total_expected: 0.00,
    total_received: 0.00,
    total_pending: 0.00,
  },
  defaultersCount: 0,
  defaultersList: [],
  loading: false,
  error: null,
};

const feeReportsSlice = createSlice({
  name: "feeReports",
  initialState,
  reducers: {
    setFeeReportFilter: (state, action) => {
      state.filterContext = { ...state.filterContext, ...action.payload };
    },
    clearFeeReportsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      /* ===== FETCH FEE REPORTS SUMMARY ===== */
      .addCase(fetchFeeReportsSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeeReportsSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.filterContext = action.payload.filter_context || state.filterContext;
        state.financialSummary = action.payload.financial_summary;
        state.defaultersCount = action.payload.defaulters_count;
        state.defaultersList = action.payload.defaulters_list;
      })
      .addCase(fetchFeeReportsSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFeeReportFilter, clearFeeReportsError } = feeReportsSlice.actions;

export default feeReportsSlice.reducer;